module.exports = __webpack_public_path__ + "images/3b57dc87e752634655a8b03e576b5708.svg";